// MODALS
// Determine if the modal should be open or close
export const MODAL_OPEN = 'MODAL_OPEN';

// Indicates which modal is being used 
export const MODAL_ID = 'MODAL_ID';


// FORM
// Captures the rating input amount
export const RATING_AMOUNT = 'RATING_AMOUNT';

// Captures which star is being hovered
export const RATING_HOVER = 'RATING_HOVER';

// All Result Data
export const RESULTS_ARRAY = 'RESULTS_ARRAY';

// Id for Result that is being edited 
export const RESULTS_EDIT_ID = 'RESULTS_EDIT_ID';

// Current result that is being edited 
export const CURRENT_RESULT = 'CURRENT_RESULT';


// RESULTS
// Captures the index of the result row 
export const ROW_INDEX = 'ROW_INDEX';

// Captures if a result row that should have it's CSS class adjusted 
export const ROW_CLASS_CONTROL = 'ROW_CLASS_CONTROL';

// Captures the index of the result card 
export const CARD_INDEX = 'CARD_INDEX';

// Captures if a result card that should have it's CSS class adjusted 
export const CARD_CLASS_CONTROL = 'CARD_CLASS_CONTROL';

// Captures the view type for the results section 
export const RESULT_VIEW_TOGGLE = 'RESULT_VIEW_TOGGLE';
